import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  private networkStatusSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public networkStatus$: Observable<boolean> = this.networkStatusSubject.asObservable();
  private snackBarRef: any;

  constructor(private snackBar: MatSnackBar, private router: Router) {
    window.addEventListener('online', this.updateNetworkStatus.bind(this));
    window.addEventListener('offline', this.updateNetworkStatus.bind(this));
    this.updateNetworkStatus();
  }

  private updateNetworkStatus(): void {
    const isOnline = navigator.onLine;
    this.setNetworkStatus(isOnline);
  }

  public setNetworkStatus(status: boolean): void {
    if (this.networkStatusSubject.getValue() !== status) {
      this.networkStatusSubject.next(status);
      if (!status) {
        this.showOfflineMessage();
      } else {
        this.dismissOfflineMessage();
      }
    }
  }

  private showOfflineMessage(): void {
    const config: MatSnackBarConfig = {
        duration: 0,
        panelClass: ['snackbar-offline'], 
        horizontalPosition: 'center',    
        verticalPosition: 'top',         
      };
      this.snackBarRef = this.snackBar.open('You are offline. Please check your internet connection.', 'Retry', config);

      this.snackBarRef.onAction().subscribe(() => {
        console.log('User clicked Retry.');
        if (navigator.onLine) {
          window.location.reload();
        } else {
          this.showOfflineMessage();
        }
      });
  }

  private dismissOfflineMessage(): void {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
      this.snackBarRef = null;
      if (this.router.url === '/dealers') {
        console.log('NetworkService: Online, reloading page for /dealers path.');
        window.location.reload();
      } else {
        console.log('NetworkService: Online, but not on /dealers path. Not reloading.');
      }
    }
  }
}